import styled from "styled-components";
import SistemaList from "~/pages/Sistema/componentes/SistemaList";
import { Scrollbars } from "react-custom-scrollbars";
import { Colors } from "~/config/Colors";

export const Main = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;

export const LandPage = styled(Scrollbars)`
    width: calc(100% - 10em) !important;

    .content {
        padding: 3em 2em 2em 2em;
    }
`;

export const Content = styled.div`
    width: 6em;
`;

export const Container = styled(SistemaList)``;

